import { validateToken, redirectToLogin } from '../../../utils/auth/tokenValidation';
import { TRANSACTION_DATA, TRANSACTION_START,TRANSACTION_END} from "../type";

interface Action {
  type: string;
  payload?: any; 
  loading?: boolean;
}


interface TransactionParams {
  page?: number;
  size?: number;
  fromDate?: string;
  toDate?: string;
  minTrxAmount?: number;
  maxTrxAmount?: number;
  bankTransactionId?: string;
  customerIdentifier?: string;
  branchIdentifier?: string;
  accountShortName?: string;
  fileId?: number;
  sortBy?: string;
  direction?: 'ASC' | 'DESC';
}

type Dispatch = (action: Action) => void;


const API_URL = process.env.REACT_APP_API_URL


export const getTransaction = (params: TransactionParams = {}) => async (dispatch: Dispatch): Promise<void> => {
  
  if (!validateToken()) {
    redirectToLogin();
    return;
  }
  
  try {
    // Clear old data first
    dispatch({
      type: TRANSACTION_START,
      payload: [],
      loading: true,
    });

    const token = localStorage.getItem("loginToken");
    if (!token) {
      throw new Error("Authorization token not found");
     
    }


      const queryParts: string[] = [];

      if (params.page !== undefined)    queryParts.push(`page=${params.page}`);
      if (params.size !== undefined)     queryParts.push(`size=${params.size}`);
      if (params.fromDate)               queryParts.push(`fromDate=${encodeURIComponent(params.fromDate)}`);
      if (params.toDate)                 queryParts.push(`toDate=${encodeURIComponent(params.toDate)}`);
      if (params.minTrxAmount !== undefined) queryParts.push(`minTrxAmount=${params.minTrxAmount}`);
      if (params.maxTrxAmount !== undefined) queryParts.push(`maxTrxAmount=${params.maxTrxAmount}`);
      if (params.bankTransactionId)      queryParts.push(`bankTransactionId=${encodeURIComponent(params.bankTransactionId)}`);
      if (params.customerIdentifier)     queryParts.push(`customerIdentifier=${encodeURIComponent(params.customerIdentifier)}`);
      if (params.branchIdentifier)       queryParts.push(`branchIdentifier=${encodeURIComponent(params.branchIdentifier)}`);
      if (params.accountShortName)       queryParts.push(`accountShortName=${encodeURIComponent(params.accountShortName)}`);
      if (params.fileId !== undefined)   queryParts.push(`fileId=${params.fileId}`);
      if (params.sortBy)                 queryParts.push(`sortBy=${encodeURIComponent(params.sortBy)}`);
      if (params.direction)              queryParts.push(`direction=${params.direction}`);

      const queryString = queryParts.length > 0 ? `?${queryParts.join('&')}` : '';


    const response = await fetch(`${API_URL}/api/trx${queryString}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      }
    );
    if (response.status === 200) {
      const res = await response.json();
      dispatch({
        type: TRANSACTION_DATA,
        payload: [{ res }], 
        loading: false,
      });
    } else {
      const res = await response.json();
      dispatch({
        type: TRANSACTION_END,
        payload: [{ res }], 
        loading: false,
      });
    }
  } catch (error) {
    dispatch({
      type: TRANSACTION_END,
      payload: false,
      loading: false,
    });
    console.error(error);
  }
};


export const getUploadedFiles = () => async (dispatch: Dispatch): Promise<any> => {
  if (!validateToken()) { redirectToLogin(); return; }

  
    const token = localStorage.getItem("loginToken");
    if (!token) {
      throw new Error("Authorization token not found");
     
    }

  try {
    const response = await fetch(`${API_URL}/campaign/get-uploaded-files/0/1000`, {
      method: 'GET',
      headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
    });

    const res = await response.json();
    return { success: response.ok, data: res };
  } catch (error) {
    return { success: false };
  }
};
